<section class="bg-white section-gap-80 mt-blog-mobile " style="    margin-top: -36px;
">

  <div class="container mt-blog-mobile ">
    <div class="row justify-content-center align-items-center">
      <div class="col-lg-5 col-md-10 order-lg-last">
        <div class="tile-gallery-three round" style="
      background-color: white; 
      margin-top: 86px; 
      width: 104% !important;
  ">
          <div class="image-one">
            <img src="../../../../assets/app-assets/images/fotografias/varejo/einstein.png" style="border-radius: 20px;
            margin-left: -8px;
        " alt="Image" />
          </div>
        </div>
      </div>
      <div class="col-lg-7 col-md-8 col-sm-10 mt-blog-mobile  ">
        <div class="feature-content pr-xl-5 mt-md-50">
          <div class="section-heading mt-5 ">
            <span class="subt-title-left span-30px"> Pronto Atendimento <i class="title-left">Virtual</i></span>
            <!-- <h2 class="title-left" style="line-height: 1.1">Virtual</h2> -->
          </div>
          <p class="mt-1">
            Um serviço exclusivo e desenvolvido pelo Einstein.
            Einstein Conecta é uma plataforma que disponibiliza profissionais do Einstein, seguindo diretrizes de
            atendimento similares ao de um Pronto Atendimento. Assim, sempre que sentir algum mal estar de baixa
            urgência, busque por orientação profissional. É importante lembrar, que o acesso ao Einstein Conecta não dá
            direito a outros serviços do Hospital Israelita Albert Einstein.
          </p>

          <div class="container mt-2 mb-mobile-40">
            <div class=" row justify-content-center align-items-center">

              <div class="col-12 col-xl-4 col-lg-6 col-md-12 col-sm-2  d-none d-sm-none d-lg-block d-md-none">
                <img src="../../../../assets/app-assets/images/icones-geia/varejo/atendimento.png" alt="element 05"
                  height="110" class="mb-1">
              </div>
              <div class="col-12 col-xl-4 col-lg-6 col-md-12 col-sm-2 d-none d-sm-none d-lg-block d-md-none">

                <img src="../../../../assets/app-assets/images/icones-geia/varejo/qualidade.png" alt="element 05"
                  height="110" class="mb-1">

              </div>
              <div class="col-12 col-xl-4 col-lg-6 col-md-12 col-sm-2 d-none d-sm-none d-lg-block d-md-none">

                <img src="../../../../assets/app-assets/images/icones-geia/varejo/pratico.png" alt="element 05"
                  height="110" class="mb-1">

              </div>

              <div id="carousel" class="carousel slide" data-ride="carousel">

                <div class="carousel-inner">

                  <div class="carousel-item active">
                    <div class="d-block d-sm-block d-lg-none d-md-block">
                      <img class="d-block w-100"
                        src="../../../../assets/app-assets/images/icones-geia/varejo/atendimento.png" alt="First slide">
                    </div>
                  </div>

                  <div class="carousel-item">
                    <div class="d-block d-sm-block d-lg-none d-md-block">
                      <img class="d-block w-100"
                        src="../../../../assets/app-assets/images/icones-geia/varejo/qualidade.png" alt="Second slide">
                    </div>
                  </div>
                  <div class="carousel-item">
                    <div class="d-block d-sm-block d-lg-none d-md-block">
                      <img class="d-block w-100"
                        src="../../../../assets/app-assets/images/icones-geia/varejo/pratico.png" alt="Second slide">
                    </div>
                  </div>
                </div>
                <!-- <a class="d-lg-none d-md-block carousel-control-prev" href="#carousel" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="sr-only">Previous</span>
                </a>
                <a class="d-lg-none  d-md-block carousel-control-next" href="#carousel" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="sr-only">Next</span>
                </a> -->
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>